import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { fmtUSD } from "../../lib/format";

export default function PropertyMap({ subject, comps }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!subject?.lat || !ref.current || mapRef.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors", maxZoom: 19,
    }).addTo(map);

    const home = [subject.lat, subject.lng];
    L.circle(home, { radius: 1609, color: "#0B1E8C", weight: 1, fillColor: "#0B1E8C", fillOpacity: 0.05 }).addTo(map);
    L.circleMarker(home, { radius: 10, color: "#fff", weight: 3, fillColor: "#0B1E8C", fillOpacity: 1 })
      .addTo(map).bindPopup(`<strong>${subject.normalized || "Your home"}</strong>`);

    const pts = [home];
    (comps || []).forEach((c) => {
      if (c.lat && c.lng) {
        L.circleMarker([c.lat, c.lng], { radius: 7, color: "#fff", weight: 2, fillColor: "#C29B38", fillOpacity: 1 })
          .addTo(map).bindPopup(`<strong>${fmtUSD(c.sale_price)}</strong><br/>${c.address}<br/>${c.distance_miles} mi away`);
        pts.push([c.lat, c.lng]);
      }
    });
    map.fitBounds(pts, { padding: [30, 30], maxZoom: 15 });
    setTimeout(() => map.invalidateSize(), 200);

    return () => { map.remove(); mapRef.current = null; };
  }, [subject, comps]);

  if (!subject?.lat) return null;

  return (
    <div data-testid="property-map">
      <span className="eyebrow">Location &amp; Nearby Sales</span>
      <h2 className="mt-2 font-serif text-2xl sm:text-3xl text-brand-ink">Your home and comparable sales within 1 mile</h2>
      <div ref={ref} className="mt-5 h-[360px] w-full rounded-2xl overflow-hidden border border-brand-hairline relative z-0" />
      <p className="mt-2 text-xs text-brand-stone/70">
        Navy marker: your home · gold markers: recent comparable sales · shaded circle: 1-mile radius. Demonstration locations.
      </p>
    </div>
  );
}
